import { render, staticRenderFns } from "./ProjectDatasourceYext.vue?vue&type=template&id=32c03c5c"
import script from "./ProjectDatasourceYext.vue?vue&type=script&lang=ts"
export * from "./ProjectDatasourceYext.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports